export default function BottomRoundButton() {
    return <div className="bg-secondary-500 rounded-full fixed bottom-20 right-6 text-3xl shadow-lg shadow-secondary-500/40">
        <i className="fa-solid fa-qrcode align-middle w-14 h-14 table-cell text-center text-white "></i>
    </div>
}